module.exports = __webpack_public_path__ + "static/media/-_approval list.0c499c65.png";